import { Text, makeStyles, tokens } from '@fluentui/react-components';
import type { NutritionFact } from '../types/catering';

const useStyles = makeStyles({
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  caption: {
    textAlign: 'left',
    paddingBottom: tokens.spacingVerticalS,
  },
  cell: {
    padding: `${tokens.spacingVerticalS} 0`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  label: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  value: {
    textAlign: 'right',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightMedium,
  },
});

export type NutritionTableProps = {
  rows: NutritionFact[];
};

export function NutritionTable({ rows }: NutritionTableProps) {
  const styles = useStyles();
  return (
    <table className={styles.table}>
      <caption className={styles.caption}>
        <Text weight="semibold">Nutrition composition</Text>
      </caption>
      <tbody>
        {rows.map((row) => (
          <tr key={row.nutritive.name}>
            <th className={`${styles.cell} ${styles.label}`} scope="row">
              {row.nutritive.name}
            </th>
            <td className={`${styles.cell} ${styles.value}`}>
              {row.measure} {row.measureUnitName}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
